import React, { useEffect, useMemo } from 'react';
import { MapContainer, TileLayer, Marker, Tooltip, useMap } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

const redIcon = L.icon({
  iconUrl: '/image/redIcon.svg',
  iconSize: [15, 15],
});

const greenIcon = L.icon({
  iconUrl: '/image/greenIcon.svg',
  iconSize: [15, 15],
});

const blueIcon = L.icon({
  iconUrl: '/image/blueIcon.svg',
  iconSize: [15, 15],
});

const DEFAULT_POSITION = [53.18442135, 50.12827981];

const isEmptyCoordinate = (value) =>
  value === null || value === undefined || (typeof value === 'string' && value.trim() === '');

const normalizeCoordinate = (coordinate) => {
  if (!Array.isArray(coordinate) || coordinate.length !== 2) {
    return null;
  }

  const rawLat = coordinate[0];
  const rawLon = coordinate[1];

  if (isEmptyCoordinate(rawLat) || isEmptyCoordinate(rawLon)) {
    return null;
  }

  const lat = Number(rawLat);
  const lon = Number(rawLon);

  if (!Number.isFinite(lat) || !Number.isFinite(lon)) {
    return null;
  }

  return [lat, lon];
};

function MyMap({ markers }) {
  const ChangeView = ({ center, zoom }) => {
    const map = useMap();

    useEffect(() => {
      if (!center) {
        return;
      }

      map.setView(center, zoom);
    }, [map, center, zoom]);

    return null;
  };

  const normalizedMarkers = useMemo(() => {
    if (!Array.isArray(markers)) {
      return [];
    }

    return markers.reduce((acc, marker) => {
      const position = normalizeCoordinate(marker?.position);

      if (position) {
        acc.push({
          ...marker,
          position,
        });
      }

      return acc;
    }, []);
  }, [markers]);

  // Вычисляем позицию на основе первого элемента markers
  const position = useMemo(() => {
    if (normalizedMarkers.length > 0) {
      return normalizedMarkers[0].position;
    }

    return DEFAULT_POSITION;
  }, [normalizedMarkers]);

  // Функция для получения иконки
  const getIcon = (type) => {
    switch (type) {
      case 'green':
        return greenIcon;
      case 'red':
        return redIcon;
      case 'blue':
        return blueIcon;
      default:
        return redIcon;
    }
  };

  return (
    <MapContainer
      center={position}
      zoom={13}
      scrollWheelZoom={true}
      style={{ height: '100%', width: '100%', borderRadius: 'var(--sadr-font-size-10)' }}
      attributionControl={false}
    >
      <ChangeView center={position} zoom={13} />
      <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
      {normalizedMarkers.map((marker, index) => (
        <Marker key={index} position={marker.position} icon={getIcon(marker.type)}>
          <Tooltip>{marker.popupContent}</Tooltip>
        </Marker>
      ))}
    </MapContainer>
  );
}

export default MyMap;
